import { render, staticRenderFns } from "./RemapHistoryTab.vue?vue&type=template&id=cc0f3930&scoped=true&"
import script from "./RemapHistoryTab.vue?vue&type=script&lang=js&"
export * from "./RemapHistoryTab.vue?vue&type=script&lang=js&"
import style0 from "./RemapHistoryTab.vue?vue&type=style&index=0&id=cc0f3930&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc0f3930",
  null
  
)

export default component.exports